<template>
  <main v-if="skill">
    <h2>Skill: {{ skill.name }}</h2>

    <div class="skill">
      <div class="skill-detail">
        <p class="skill-name" :style="{
          backgroundColor: skill.color,
          color: getTextColor(skill.color),
        }">
          {{ skill.name }}
        </p>
        <p class="skill-weight">
          weight: {{ skill.weight }}
          <img v-if="skill.weight >= 1 && skill.weight <= 2" :src="`../../img/weight/12.png`" alt="elementary" />
          <img v-if="skill.weight >= 3 && skill.weight <= 4" :src="`../../img/weight/34.png`" alt="intermediate" />
          <img v-if="skill.weight >= 5 && skill.weight <= 6" :src="`../../img/weight/56.png`" alt="advanced" />
          <img v-if="skill.weight >= 7 && skill.weight <= 8" :src="`../../img/weight/78.png`" alt="professional" />
          <img v-if="skill.weight >= 9 && skill.weight <= 10" :src="`../../img/weight/90.png`" alt="expert" />
        </p>
        <p class="skill-description markdown-content" v-html="markdown2(skill.description)"></p>
      </div>
      <div>
        <p><img :src="skill.icon" alt="" /></p>
      </div>
    </div>

    <h3 class="main">Used in Projects:</h3>
    <ul class="projects">
      <li v-for="project in skill.projects" :key="project.id">
        <RouterLink :to="{ name: 'project-detail', params: { id: project.id } }">
          {{ project.name }}
        </RouterLink>
      </li>
    </ul>
  </main>
  <main v-else>
    <loading :status="status" />
  </main>
</template>

<style lang="scss" scoped>
h3.main {
  margin-left: 1rem;
  font-size: 2rem;
  color: $primari;
}

.skill {
  width: 91%;
  display: flex;

  div.skill-detail {
    text-align: left;
    flex: 1;
    margin: 1rem;

    .skill-name {
      display: inline-block;
      font-weight: bold;
      font-size: 2em;
      border-radius: 2ex;
      padding: 0.2em 0.5em;
      margin: 0.2em 0.5em;
      border-radius: 1ex;
    }
  }

  div {
    text-align: center;
    flex: 1;
    margin: 1rem;
  }

  .skill-description {
    border: 2px solid #ccc;
    margin: 1rem;
    padding: 1rem;
  }

  .skill-weight {
    font-size: 1.4em;
    margin: 1rem;
    padding: 1rem;

    img {
      margin-left: 2rem;
      vertical-align: middle;
    }
  }
}

ul.projects {
  margin-top: 1rem;
  padding-left: 10%;
  font-size: 1.2rem;

  li {
    margin: 0.4rem 0;
  }

  a {
    color: $btnColor;
  }

}

.center {
  text-align: center;

  img {
    max-width: 50%;
  }
}
</style>

<script setup>
import { useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'
import { api } from '../utils/axios'
import { markdown2, getTextColor } from '../utils/helpers'
import loading from '@/components/loading.vue'

const route = useRoute()
const skillId = route.params.id
const skill = ref(null)
const status = ref('loading')

onMounted(async () => {
  try {
    const response = await api.get(`/skill/${skillId}`)
    skill.value = response.data
  } catch (error) {
    status.value = error.response?.data?.msg || 'Error fetching skill data'
    console.error('Error fetching skill:', error)
  }
})

//const abc = new URL('../../img/weight/12.png', '@')
//console.log( abc.href )
</script>
